import styled from "styled-components";


export const MemberCardFamilyMembers = styled.div`

  .MuiAvatar-colorDefault {
    background-color: ${props => props.backgroundColor || "rgba(0, 0, 0, 0.1)"};
    color: ${props => props.color || "#2555ef"};
  }

`